import { render, staticRenderFns } from "./ApartmanAlacakForm.vue?vue&type=template&id=6262d181"
import script from "./ApartmanAlacakForm.vue?vue&type=script&lang=ts"
export * from "./ApartmanAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports